import './About.css';

function About() {
    return (
        <div className="about-page">
            <div className="about-header">
                <h1>About</h1>
            </div>
            <div className="about-body">
                <p>Welcome to my mountaineering diary! I'm Jake, a rider from the Bay Area. I love road, mountain, and gravel cycling around my home mountains and anywhere that has cool trails &amp; views.</p>
            </div>
        </div>
    );
}

export default About;
